// @ts-ignore
import { DateTime } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ItemTaskType, ItemType } from '../types';
import GantItemGroupTask from './gantItemGroupTask';

interface IGantItemListOfGroupTask {
    item: ItemType;
    offsetX: number;
}

const GantItemListOfGroupTask: React.FC<IGantItemListOfGroupTask> = ({ item, offsetX }) => {
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);

    const storeTaskByDate: { [key: string]: ItemTaskType[] } = {};

    item.tasks?.forEach((task) => {
        if (!storeTaskByDate[task.datetime]) {
            storeTaskByDate[task.datetime] = [];
        }
        storeTaskByDate[task.datetime].push(task);
    });

    return (
        <>
            {Object.keys(storeTaskByDate).map((key) => {
                const groupTask = storeTaskByDate[key];
                const [task] = groupTask;
                const diff = DateTime.fromSQL(task.datetime).diff(DateTime.fromISO(item.startDate), 'days').days;

                return (
                    <GantItemGroupTask
                        key={key}
                        groupTask={groupTask}
                        positionX={offsetX + widthColumn / 2 + diff * widthColumn}
                    />
                );
            })}
        </>
    );
};

export default GantItemListOfGroupTask;
